import { Component, OnInit, Inject, EventEmitter, Output } from "@angular/core";
import { CommonModule, DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { Claims } from "src/app/_models/common/claims";
import { AuthenticationService } from "src/app/_services";
import { NavMenuComponent } from "../../nav-menu/nav/nav-menu.component";
import { DsDashboardActionBtnComponent } from "../../shared/design-system/ds-dashboard-component/ds-dashboard-action-btn/ds-dashboard-action-btn.component"; 
import { ICONS } from "../../_helpers/icons.constants";
import { Constants } from "../../../util/constants";
@Component({
    selector: "app-topbar",
    templateUrl: "./topbar.component.html",
    standalone: true,
    imports: [CommonModule, NavMenuComponent, DsDashboardActionBtnComponent]
})

export class TopbarComponent implements OnInit {
  showMenuButton: boolean = true;
  isMobileMenuOpen: boolean = false;
  element: any;
  flagvalue: any;
  cookieValue: any;
  countryName: any;
  valueset: any;
  claims: Claims;
  imageSource='assets/images/logo.png';
  public ICONS = ICONS;
  isMobileView: boolean = false;
  isNotificationPanelActive: boolean = false;
  routerLink:  string = "";

  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private authService: AuthenticationService,
    public _cookiesService: CookieService,
    private claimsService: ClaimsService,
  ) {
    this.claimsService.currentClaims.subscribe((claims: Claims) => {
      this.claims = claims;
      if(this.claims)
        {
          this.imageSource = this.claims.OrgLogo;
        }      
    });
  }
  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit(): void {
    this.element = document.documentElement;
    this.checkMobileView();
    window.addEventListener('resize', this.checkMobileView.bind(this));
  }

  checkMobileView() {
    this.isMobileView = window.innerWidth <= Constants.MOBILE_VIEW_WIDTH;
  }

  toggleMobileMenu() {
    this.showMenuButton = !this.showMenuButton;
    this.mobileMenuButtonClicked.emit();
  }

  toggleNavMenu() { 
    this.isMobileView = !this.isMobileView;
  }

  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  logout() {
      this.authService.logout();
    this.router.navigate(["/login"]);
  }
}
